/**
 * Ein Knopf, den erst ein **zweiter Klick** auslöst (`R12`, Entscheidung des Users 2026-10-13).
 *
 * Für Handlungen, die sich nicht zurücknehmen lassen — „Partie beenden" im Spiel, „Partie
 * schließen" in der Lobby. Der erste Klick macht aus dem Knopf die Rückfrage, erst der zweite
 * löst aus. Ohne zweiten Klick fällt er nach `timeoutMs` zurück. Dasselbe Muster wie beim Zug
 * seit `R7`, ohne Dialogfenster — ein neues Bedienelement im Rahmen „Werkbank" (**E36**) wäre
 * mehr als die Absicherung braucht.
 */

import { useEffect, useState } from 'react';

export interface ConfirmButtonProps {
  readonly label: string;
  readonly confirmLabel: string;
  readonly onConfirm: () => void;
  /** Wie lange die Rückfrage stehen bleibt. */
  readonly timeoutMs?: number;
}

export function ConfirmButton({ label, confirmLabel, onConfirm, timeoutMs = 4_000 }: ConfirmButtonProps) {
  const [armed, setArmed] = useState(false);

  useEffect(() => {
    if (!armed) return undefined;
    const timer = setTimeout(() => setArmed(false), timeoutMs);
    return () => clearTimeout(timer);
  }, [armed, timeoutMs]);

  return (
    <button
      type="button"
      data-armed={armed ? 'true' : undefined}
      onClick={() => {
        if (!armed) {
          setArmed(true);
          return;
        }
        setArmed(false);
        onConfirm();
      }}
    >
      {armed ? confirmLabel : label}
    </button>
  );
}
